import axios from 'axios'

axios.defaults.headers.post['Content-Type'] = 'application/json'

const braintreeApi = axios.create({
  baseURL: 'http://localhost:5001/hero-hire-1178c/us-central1/',
  headers: {
    'Content-Type': 'application/json'
  }
})

export default {
  braintreeApi
}
